import createCache from "@emotion/cache"
import rtlPlugin from "stylis-plugin-rtl"
import { prefixer } from "stylis"

export const rtlCache = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
})

export const ltrCache = createCache({
  key: "muiltr",
})

export const getCacheByThemeDirection = (direction) => {
  return direction === "rtl" ? rtlCache : ltrCache
}
